// extracted by mini-css-extract-plugin
module.exports = {"popoverContent":"PopoverComponent_popoverContent__24NtR","tbodyText":"PopoverComponent_tbodyText__2pv8A"};